<template>
    <v-container>
        <form>
            <v-row justify="center">
                <v-col cols=12 md=6>
                    <v-card shaped class="pa-5">
                        <v-container>
                            <v-row justify="center">
                                <v-col class="display-3 mb-3">
                                    Log In
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col class="px-auto">
                                    <v-text-field label="Email" v-model="username" required class="px-auto"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col>
                                    <v-text-field label="Password" v-model="password" required type="password"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row justify="center">
                                <v-col class="text-right">
                                    <v-btn block color="blue" dark @click="login" :loading="loading">Submit</v-btn>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </form>
    </v-container>
</template>

<script>
import rp from "request-promise-native"

export default {
    // Prevent the user from accessing the login page if they are already logged in.
    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (vm.$store.state.token.length > 0) {            
                next("/dashboard");
            } else {
                next();
            }
        })
    },
    data() {
        return {
            loading: false
        }
    },
    computed: {
        username: {
            get() {
                return this.$store.state.username;
            },
            set(val) {
                this.$store.commit("setUsername", val);
            }
        },
        password: {
            get() {
                return this.$store.state.password;
            },
            set(val) {
                this.$store.commit("setPassword", val)
            }
        }
    },
    mounted: function() {
        // TODO: Remove after testing
        console.log(process.env.VUE_APP_HOST); 
    },
    methods: {
        login() {
            // Set the loading to be true
            this.loading = true;
            // To be able to access the Vue instance from within other functions.
            let self = this;
            let options = {
                method: 'POST',
                uri: `${process.env.VUE_APP_HOST}/users/login`,
                body: {
                    email: self.$store.state.username,
                    password: self.$store.state.password
                },
                json: true // Automatically stringifies the body to JSON
            };
            
            rp(options)
            .then(function (parsedBody) {
                // Clear the password
                self.$store.commit("clearPassword");

                // Set the token
                self.$store.commit("setToken", parsedBody.token);

                // Set the name
                self.$store.commit("setName", parsedBody.user.name);

                // Move to another route
                self.$router.push("dashboard");
                
            })
            .catch(function (err) {
                console.log(err);
                self.loading = false;
                
            });          
        }
    }
}
</script>